// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9832b6ed","239":"d42affff","453":"94fba212","732":"51e35538"}[chunkId] + ".chunk.js";
};